import { WebApp } from '@grammyjs/web-app'
import type { App } from 'vue'

const addImpact = (type: 'light' | 'medium' | 'heavy' | 'soft' | 'rigid') => {
	return () => {
		try {
			if (type === 'soft') {
				WebApp.HapticFeedback.impactOccurred('soft')
			}
			if (type === 'rigid') {
				WebApp.HapticFeedback.impactOccurred('rigid')
			}
			if (type === 'light') {
				WebApp.HapticFeedback.impactOccurred('light')
			}
			if (type === 'medium') {
				WebApp.HapticFeedback.impactOccurred('medium')
			}
			if (type === 'heavy') {
				WebApp.HapticFeedback.impactOccurred('heavy')
			}
		} catch (e) {
			console.error('HAPTIC ERROR', e)
		}
	}
}

const addClassName = (el: HTMLElement, className: string) => {
	return () => {
		el.classList.add(...className.split(' '))
	}
}

const removeClassName = (el: HTMLElement, className: string) => {
	return () => {
		el.classList.remove(...className.split(' '))
	}
}

export const hoverDirective = (app: App) => {
	app.directive('hover', {
		mounted: (el, binding) => {
			const {
				active = 'enabled:scale-95',
				transition = 'transition-transform duration-100',
				impact = 'medium'
			} = binding.value || {}

			el.classList.add(...transition.split(' '), 'cursor-pointer')
			el.addEventListener('click', addImpact(impact))
			el.addEventListener('touchstart', addClassName(el, active))
			el.addEventListener('touchend', removeClassName(el, active))
		},
		unmounted: (el, binding) => {
			const {
				active = 'enabled:scale-95',
				transition = 'transition-transform duration-100',
				impact = 'medium'
			} = binding.value || {}

			el.classList.remove(...transition.split(' '), 'cursor-pointer')
			el.removeEventListener('click', addImpact(impact))
			el.removeEventListener('touchstart', addClassName(el, active))
			el.removeEventListener('touchend', removeClassName(el, active))
		}
	})
}
